"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4531],{

/***/ 64531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_1__);


var FaqsBanner = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var faqData = props === null || props === void 0 ? void 0 : (ref = props.faqBannerData) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.Section;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container-xl custom-container px-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            className: "hero-section",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "hero-banner FAQ-banner",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            sizes: "(max-width: 375px) 320px, (max-width: 576px) 576px, (max-width: 768px) 768px, (max-width: 992px) 992px, (max-width: 1280px) 1280px",
                            src: (ref4 = (ref2 = faqData[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Background_Image) === null || ref3 === void 0 ? void 0 : ref3.data.attributes) === null || ref4 === void 0 ? void 0 : ref4.url,
                            alt: ((ref7 = (ref5 = faqData[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.Background_Image) === null || ref6 === void 0 ? void 0 : ref6.data.attributes) === null || ref7 === void 0 ? void 0 : ref7.alternativeText) || ((ref10 = (ref8 = faqData[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.Background_Image) === null || ref9 === void 0 ? void 0 : ref9.data.attributes) === null || ref10 === void 0 ? void 0 : ref10.name),
                            className: "banner-img",
                            width: "1280",
                            height: "516"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "banner-content",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "col-lg-12 col-md-12 col-sm-12 m-auto",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            children: (ref11 = faqData[0]) === null || ref11 === void 0 ? void 0 : ref11.Title
                                        })
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "promotion-banner",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: (ref12 = faqData[1]) === null || ref12 === void 0 ? void 0 : ref12.Title
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FaqsBanner);


/***/ })

}]);